<ng-template [ngIf]="isUserDetailsAvailable" [ngIfElse]="spinner">

    <!-- STEP 1 -->
    <div *ngIf="currentStep === 1; else lastPageData" class="hvac-user-admin-container">
        <h1 class="hvac-p-sm hvac-user-admin-roles-heading">
            {{ 'USER_ADMIN.USER_SECURITY.ROLE_GROUPING' | translate | uppercase}}
        </h1>

        <hvac-tab-bar class="hvac-user-roles-tab-bar" variant="secondary">
            <button
                *ngFor="let tab of visibleAuthorizedRoles; let i = index"
                (click)="onRoleTabChange(i)"
                [ngClass]="{ 'hvac-active' : selectedRoleTab === i }">
                {{ tab.roleCategory }}
            </button>
        </hvac-tab-bar>
        <div class="hvac-no-roles-error" *ngIf="noAuthorizedRoles">
            <h3>{{"USER_ADMIN.USER_SECURITY.NO_AUTHORIZED_ROLES"| translate}}</h3>
        </div>
        <div class="hvac-no-roles-error" *ngIf="!noAuthorizedRoles && currentRoles.length === 0">
            <h3>{{"USER_ADMIN.USER_SECURITY.NO_ROLES_IN_TAB"| translate}}</h3>
        </div>

        <hvac-table class="hvac-user-admin-table-wrap-roles" [theme]="'zebra'" [responsive]="true">
            <tbody>
                <tr *ngFor="let role of currentRoles; trackBy: trackByRole">
                    <td class="hvac-checkbox-container">
                        <utc-checkbox
                            [checked]="isRoleSelected(role)"
                            (change)="toggleRole(role)">
                        </utc-checkbox>
                    </td>

                    <td class="hvac-user-admin-table-row-data">
                        {{ role.roleDisplayName }}
                    </td>

                    <td class="hvac-user-admin-table-row-details">
                        <a class="hvac-text-link"
                           (click)="onSelectRoleAndFeatureDetails(role, null)">
                            {{ "USER_ADMIN.USER_SECURITY.ROLE_DETAILS" | translate }}
                        </a>
                    </td>
                </tr>
            </tbody>
        </hvac-table>
    </div>

    <!-- STEP 2 -->
    <ng-template #lastPageData>
        <div class="hvac-user-admin-container">
            <h1 class="hvac-p-sm hvac-user-admin-roles-heading">
                {{ 'USER_ADMIN.USER_SECURITY.ADDITIONAL_ACCESS' | translate | uppercase}}
            </h1>

            <hvac-tab-bar class="hvac-user-roles-tab-bar" variant="secondary">
                <button
                    *ngFor="let tab of authorizedFeatures; let i = index"
                    (click)="onFeatureTabChange(i)"
                    [ngClass]="{ 'hvac-active' : selectedFeatureTab === i }">
                    {{ tab.featureCategory }}
                </button>
            </hvac-tab-bar>
            <div class="hvac-no-roles-error" *ngIf="noAuthorizedFeatures">
                <h3>{{"USER_ADMIN.USER_SECURITY.NO_AUTHORIZED_FEATURES"| translate}}</h3>
            </div>
            <div class="hvac-no-roles-error" *ngIf="!noAuthorizedFeatures && currentFeatures.length === 0">
                <h3>{{"USER_ADMIN.USER_SECURITY.NO_FEATURES_IN_TAB"| translate}}</h3>
            </div>

            <hvac-table class="hvac-user-admin-table-wrap-roles" [theme]="'zebra'" [responsive]="true">
                <tbody>
                    <tr *ngFor="let feature of currentFeatures; trackBy: trackByFeature">
                        <td class="hvac-checkbox-container">
                            <utc-checkbox
                                [checked]="isFeatureSelected(feature)"
                                (change)="toggleFeature(feature)">
                            </utc-checkbox>
                        </td>

                        <td class="hvac-user-admin-table-row-data">
                            {{ feature.featureDisplayName }}
                        </td>

                        <td class="hvac-user-admin-table-row-details">
                            <a class="hvac-text-link"
                               (click)="onSelectRoleAndFeatureDetails(null, feature)">
                                {{ 'USER_ADMIN.USER_SECURITY.FEATURE_DETAILS' | translate}}
                            </a>
                        </td>
                    </tr>
                </tbody>
            </hvac-table>
        </div>
    </ng-template>

    <!-- SUMMARY -->
    <section class="hvac-user-admin-container hvac-user-info-brief-container">
        <div class="hvac-user-info-brief-header">
            <div class="hvac-user-info-header">
                <h2>{{ "USER_ADMIN.USER_SUMMARY" | translate }}</h2>
            </div>

            <div (click)="getUserDetailsSummery()" class="hvac-user-info-down-arrow">
                <utc-svg class="hvac-text-link" src="assets/icons/chevron-down.svg"></utc-svg>
            </div>
        </div>

        <div [ngClass]="{'hidden': !isUserDetailsSummeryMode}">
            <div class="hvac-divider"></div>

            <hvac-table class="hvac-user-admin-table-wrap-user-info" [theme]="'zebra'" [responsive]="true">
                <tbody>
                    <tr>
                        <td class="hvac-user-admin-table-row-data">
                            {{ 'USER_ADMIN.USER_SECURITY.USER_SUMMARY.USER_ID' | translate}}
                        </td>
                        <td class="hvac-user-admin-table-row-details">
                            <div class="hvac-col-xs hvac-account-admin-detail-list-value hvac-non-edit-mode">
                                {{ userIdToDisplay }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td class="hvac-user-admin-table-row-data">
                            {{ 'USER_ADMIN.USER_SECURITY.USER_SUMMARY.USER_NAME' | translate}}
                        </td>
                        <td class="hvac-user-admin-table-row-details">
                            <div class="hvac-col-xs hvac-account-admin-detail-list-value hvac-non-edit-mode">
                                {{ userFullName }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td class="hvac-user-admin-table-row-data">
                            {{ 'USER_ADMIN.USER_SECURITY.USER_SUMMARY.COMPANY_INFORMATION' | translate}}
                        </td>
                        <td class="hvac-user-admin-table-row-details">
                            <div class="hvac-col-xs hvac-account-admin-detail-list-value hvac-non-edit-mode">
                                {{ companyInfo }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td class="hvac-user-admin-table-row-data">
                            {{ 'USER_ADMIN.USER_SECURITY.USER_SUMMARY.DEFAULT_ROLES' | translate}}
                        </td>
                        <td class="hvac-user-admin-table-row-details">
                            <ul>
                                <li *ngFor="let role of summary.defaultRoles"
                                    class="hvac-col-xs hvac-account-admin-detail-list-value hvac-non-edit-mode">
                                    {{ role.roleDisplayName }}
                                </li>
                            </ul>
                        </td>
                    </tr>

                    <tr>
                        <td class="hvac-user-admin-table-row-data">
                            {{ 'USER_ADMIN.USER_SECURITY.USER_SUMMARY.SELECTED_ROLES' | translate}}
                        </td>
                        <td class="hvac-user-admin-table-row-details">
                            <ul>
                                <li *ngFor="let role of summary.selectedRoles"
                                    class="hvac-col-xs hvac-account-admin-detail-list-value hvac-non-edit-mode">
                                    {{ role.roleDisplayName }}
                                </li>
                            </ul>
                        </td>
                    </tr>

                    <tr>
                        <td class="hvac-user-admin-table-row-data">
                            {{ 'USER_ADMIN.USER_SECURITY.USER_SUMMARY.FEATURES_SELECTED_BY_ROLES' | translate}}
                        </td>
                        <td class="hvac-user-admin-table-row-details">
                            <ul>
                                <li *ngFor="let feature of summary.roleFeatures"
                                    class="hvac-col-xs hvac-account-admin-detail-list-value hvac-non-edit-mode">
                                    {{ feature.featureDisplayName }}
                                </li>
                            </ul>
                        </td>
                    </tr>

                    <tr>
                        <td class="hvac-user-admin-table-row-data">
                            {{ 'USER_ADMIN.USER_SECURITY.USER_SUMMARY.ADDITIONAL_FEATURES_SELECTED' | translate}}
                        </td>
                        <td class="hvac-user-admin-table-row-details">
                            <ul>
                                <li *ngFor="let feature of summary.additionalFeatures"
                                    class="hvac-col-xs hvac-account-admin-detail-list-value hvac-non-edit-mode">
                                    {{ feature.featureDisplayName }}
                                </li>
                            </ul>
                        </td>
                    </tr>
                </tbody>
            </hvac-table>
        </div>
    </section>

    <!-- FOOTER -->
    <div class="hvac-flex-end" *ngIf="currentStep === 1; else editUserInfoFooter">
        <button type="button" class="hvac-edit-button" (click)="cancelChanges()" hvacButton="default">
            {{ 'USER_ADMIN.CANCEL' | translate}}
        </button>

        <button type="button" (click)="goNext()" class="hvac-edit-button" hvacButton="primary">
            {{ 'FOOTER.NEXT' | translate}}
        </button>
    </div>

    <ng-template #editUserInfoFooter>
        <div class="hvac-flex-end">
            <button class="hvac-edit-button" type="button" [hvacButton]="'default'" (click)="goBack()">
                <span>{{ "FOOTER.BACK" | translate }}</span>
            </button>

            <button type="button" class="hvac-edit-button" hvacButton="primary" (click)="submit()">
                {{ 'FOOTER.SUBMIT' | translate }}
                <utc-svg src="assets/icons/arrow.svg"></utc-svg>
            </button>
        </div>
    </ng-template>

</ng-template>

<!-- MODAL -->
<ng-template [ngIf]="userRoleAndFeatureDetails">
    <div class="x-overflow-hidden">
        <utc-modal modal [visible]="true" (closeAction)="userRoleAndFeatureModalClose()" size="dynamic-height" theme="rounded" class="hvac-modal-close" [showHeader]="false">
            <div class="hvac-edit-user-security-modal">
                <hvac-modal-header>
                    <h2>{{ selctedDisplayName }}</h2>
                </hvac-modal-header>

                <div class="modal-content">{{ selectedDesc }}</div>
            </div>

            <div class="hvac-divider"></div>

            <div class="display-flex-end">
                <button (click)="userRoleAndFeatureModalClose()" class="modal-button" hvacButton="primary">
                    {{'CLOSE' | translate}}
                </button>
            </div>
        </utc-modal>
    </div>
</ng-template>

<ng-template #spinner>
    <utc-loading-spinner></utc-loading-spinner>
</ng-template>
